/* Pack selector on product cards.
   Selecting a pack rewrites the card's product links with ?tier=N (picked up by
   the Bundle & Buy block on the product page) and syncs the card's quantity input. */
(function () {
  function updateCard(card, pill) {
    card.querySelectorAll('[data-pack-selector] .pack-selector__pill').forEach(function (p) {
      var active = p === pill;
      p.classList.toggle('is-active', active);
      p.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    var tier = pill.dataset.tier || '1';
    var qty = parseInt(pill.dataset.qty, 10) || 1;

    card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        url.searchParams.set('tier', tier);
        link.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (e) {}
    });

    var qtyInput = card.querySelector('input[name="quantity"]');
    if (qtyInput) {
      qtyInput.value = qty;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('click', function (evt) {
    var pill = evt.target.closest('.pack-selector__pill');
    if (!pill) return;
    evt.preventDefault();
    evt.stopPropagation();
    var card = pill.closest('product-card') || pill.closest('.product-card-wrapper');
    if (card) updateCard(card, pill);
  });
})();
